"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXTonConnect = void 0;
const core_1 = require("@okxconnect/core");
const okx_connect_ton_inner_1 = require("./okx-connect-ton-inner");
class OKXTonConnect {
    constructor(options) {
        try {
            (0, core_1.logDebug)('OKXTonConnect constructor called');
            if (window && window.okxConnectTonsdkinwindow && window.okxConnectTonsdkinwindow instanceof okx_connect_ton_inner_1.OKXTonConnectInner) {
                this.tonInner = window.okxConnectTonsdkinwindow;
                (0, core_1.logDebug)('OKXTonConnect constructor old called');
            }
            else {
                this.tonInner = new okx_connect_ton_inner_1.OKXTonConnectInner(options);
                (0, core_1.logDebug)('OKXTonConnect constructor new called');
                this.registerConnector([core_1.AppwalletConnector.getConnector()]);
                if (window) {
                    window.okxConnectTonsdkinwindow = this.tonInner;
                }
            }
        }
        catch (error) {
            throw error;
        }
    }
    /**
     * Shows if the wallet is connected right now.
     */
    get connected() {
        return this.tonInner.connected;
    }
    get openUniversalLink() {
        return this.tonInner.openUniversalLink;
    }
    get provider() {
        return this.tonInner.provider;
    }
    /**
     * Current connected account or null if no account is connected.
     */
    get account() {
        return this.tonInner.account;
    }
    /**
     * Current connected wallet or null if no account is connected.
     */
    get wallet() {
        return this.tonInner.wallet;
    }
    set wallet(value) {
        this.tonInner.wallet = value;
    }
    connect(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.tonInner.connect(request);
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.tonInner.disconnect();
        });
    }
    onStatusChange(callback, errorsHandler) {
        return this.tonInner.onStatusChange(callback, errorsHandler);
    }
    restoreConnection() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.tonInner.restoreConnection();
        });
    }
    sendTransaction(transaction, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.tonInner.sendTransaction(transaction, options);
        });
    }
    static getWallets() {
        return okx_connect_ton_inner_1.OKXTonConnectInner.getWallets();
    }
    registerConnector(connectors) {
        this.tonInner.registerConnector(connectors);
    }
}
exports.OKXTonConnect = OKXTonConnect;
